// @deprecated - please use HttpParams instead of manually constructing a URL.
// `createHttpParamsFromRecord` may work for your use case
import { HttpParams } from '@angular/common/http';

export const createQueryParams = (params?: Record<string, string | string[]>) => {
  if (!params) return '';

  const queryParts: string[] = [];

  Object.entries(params).forEach(([key, value]) => {
    if (value === '' || value === undefined) return;

    const encodedKey = encodeURIComponent(key);

    if (Array.isArray(value)) {
      value.forEach((item) => {
        queryParts.push(`${encodedKey}=${encodeURIComponent(item)}`);
      });
    } else {
      queryParts.push(`${encodedKey}=${encodeURIComponent(value)}`);
    }
  });

  return queryParts.join('&');
};

export function createHttpParamsFromRecord(params?: Record<string, string | string[]>): HttpParams {
  let httpParams = new HttpParams();
  Object.keys(params).forEach((param) => {
    if (!params[param]) return;

    if (Array.isArray(params[param])) {
      params[param].forEach((item) => {
        httpParams = httpParams.append(param, item);
      });
    } else {
      httpParams = httpParams.set(param, params[param]);
    }
  });

  return httpParams;
}
